"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var __1 = require("..");
var LayoutWritingService = /** @class */ (function () {
    function LayoutWritingService() {
    }
    LayoutWritingService_1 = LayoutWritingService;
    LayoutWritingService.formPropertiesToJs = function (form) {
        var context = {
            grids: [],
            cells: [],
            rows: []
        };
        if (form.header) {
            if (form.header instanceof __1.ControlModel) {
                context = this.controlModelPropertiesToJs(form.header, context);
            }
            else {
                context = this.gridPropertiesToJs(form.header, context);
            }
        }
        if (form.footer) {
            context = this.gridPropertiesToJs(form.footer, context);
        }
        if (form.subwayMap) {
            context = this.controlModelPropertiesToJs(form.subwayMap, context);
        }
        context = this.gridPropertiesToJs(form.content, context);
        return context;
    };
    LayoutWritingService.pagePropertiesToJs = function (page) {
        var context = {
            grids: [],
            cells: [],
            rows: []
        };
        context = this.gridPropertiesToJs(page.content, context);
        return context;
    };
    LayoutWritingService.gridPropertiesToJs = function (grid, context) {
        var _this = this;
        context.grids.push(grid.properties.toJS());
        grid.rows.forEach(function (row) { return context = _this.rowPropertiesToJs(row, context); });
        return context;
    };
    LayoutWritingService.rowPropertiesToJs = function (row, context) {
        var _this = this;
        context.rows.push(row.properties.toJS());
        row.cells.forEach(function (cell) { return context = _this.cellPropertiesToJs(cell, context); });
        return context;
    };
    LayoutWritingService.cellPropertiesToJs = function (cell, context) {
        context.cells.push({
            id: cell.properties.id,
            cellProperties: cell.properties.toJS(),
            controlProperties: cell.controlModel ?
                cell.controlModel.properties.toJS() : undefined,
        });
        if (cell.grid) {
            context = this.gridPropertiesToJs(cell.grid, context);
        }
        return context;
    };
    LayoutWritingService.controlModelPropertiesToJs = function (controlModel, context) {
        context.cells.push({
            id: controlModel.properties.id,
            cellProperties: {},
            controlProperties: controlModel.properties.toJS(),
        });
        return context;
    };
    LayoutWritingService.prototype.writeForm = function (form, formCategoryName) {
        return JSON.stringify({
            layout: JSON.stringify(form),
            property: JSON.stringify((_a = {},
                _a[formCategoryName] = (_b = {},
                    _b[form.formName] = LayoutWritingService_1.formPropertiesToJs(form),
                    _b),
                _a))
        });
        var _a, _b;
    };
    LayoutWritingService.prototype.writePage = function (page) {
        return JSON.stringify({
            layout: JSON.stringify(page),
            property: JSON.stringify((_a = {},
                _a[page.pageName] = LayoutWritingService_1.pagePropertiesToJs(page),
                _a))
        });
        var _a;
    };
    LayoutWritingService = LayoutWritingService_1 = __decorate([
        core_1.Injectable()
    ], LayoutWritingService);
    return LayoutWritingService;
    var LayoutWritingService_1;
}());
exports.LayoutWritingService = LayoutWritingService;
//# sourceMappingURL=layout-writing.service.js.map